import { Dialog } from "primereact/dialog";
import { studentsApi } from "../../services/students/studentsApi";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect } from "react";

interface MassEnrollmentDialogProps {
  visible: boolean;
  onHide: () => void;
  studentIds: number[];
}

const MassEnrollmentDialog = ({ visible, onHide, studentIds }: MassEnrollmentDialogProps) => {
  const [nextSemester] = studentsApi.useNextSemesterMutation();

  const handleEnrollment = async () => {
    try {
      for (const studentId of studentIds) {
        await nextSemester({ studentId });
      }
      onHide();
    } catch (error) {
      console.error("Error during mass enrollment:", error);
    }
  };

  useEffect(() => {
    if (visible && studentIds.length > 0) {
      handleEnrollment();
    }
  }, [visible, studentIds]);

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Записване за следващ семестър"
      style={{ width: "30vw" }}
      modal
      closable={false}
    >
      <div className="flex flex-column align-items-center">
        <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" />
        <p className="mt-3">Записване на студентите за следващ семестър...</p>
      </div>
    </Dialog>
  );
};

export default MassEnrollmentDialog; 